






import {Component, Vue} from "vue-property-decorator";
import {GuideSaveCompanyReq} from "@/model/Guide";
import {setGuideSaveCompany, getGuideDetail, sendVerifyEmail, getFlowCount} from "@/services/api";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {defaultTimezone, timezones} from "@/services/config";

@Component({
  components: {
    'yc-aside': YcAside,
    'yc-header': YcHeader
  },
})
export default class AccountSettings extends Vue {
  // 时区列表
  public timezones = timezones;
  public activeTab = 'email';
  public guideSaveCompanyReq: GuideSaveCompanyReq = {
    defaultSenderName: '',
    defaultSenderEmail: '',
    country: '',
    province: '',
    city: '',
    address: '',
    zipCode: '',
    site: '',
    name: '',
    timezone: '',
    orderAttributionMethod:'OPEN_CLICK',
    orderAttributionWindow:5,
    
  }
  public oldEmail = '';
  public count: number|null = null;

  public rules = {
    defaultSenderName:[{ required: true, message: '请输入默认发件人姓名', trigger: 'blur' }, {max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    defaultSenderEmail:[
      {required: true, message: '请输入发件人邮箱地址', trigger: 'blur' },
      {max: 200, message: '长度不能超过200个字符', trigger: 'blur' },
      {
        trigger: "blur",
        validator: (rule: any, value: any, callback: any) => {
          if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
            callback(new Error("请输入正确的邮箱地址"));
          } else {
            callback();
          }
        }
      }
      ],
    name:[{max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    site:[{max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    // country:[{ required: true, message: '请选择国家', trigger: 'blur' }],
    city:[{max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    province:[{max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    address:[{max: 200, message: '长度不能超过200个字符', trigger: 'blur' }],
    orderAttributionMethod:[{ required: true, message: '请选择归因设置', trigger: 'blur' },]
  }

  created(): void {
    // this.getGuideDetail();
    window.location.href = '/cartsee-new/account'
  }

  /**
   * 添加品牌信息
   */
  setGuideSaveCompany(): void {
    const companyForm: any = this.$refs.companyForm;
    companyForm.validate((valid: boolean) => {
      if (valid) {
        setGuideSaveCompany(this.guideSaveCompanyReq, true).then(res => {
          this.$message.success('保存成功');
          this.activeTab = 'email';
          localStorage.setItem('timezone', this.guideSaveCompanyReq.timezone|| defaultTimezone);
          if(this.oldEmail !== this.guideSaveCompanyReq.defaultSenderEmail) {
            this.$router.push(`/email/verify?email=${this.guideSaveCompanyReq.defaultSenderEmail}`)
            sendVerifyEmail({email: this.guideSaveCompanyReq.defaultSenderEmail}).then(res => {
              this.$message.success('邮件发送成功！')
            })
          }
        })
      } else {
        return false;
      }
    });
  }

  /**
   * 获取向导进度接口
   */
  async getGuideDetail(): Promise<void> {
    await getGuideDetail({},true).then(res => {
      this.guideSaveCompanyReq = res.data.data.companyInfo;
      this.guideSaveCompanyReq.timezone = this.guideSaveCompanyReq.timezone || defaultTimezone;
      this.oldEmail = res.data.data.companyInfo.defaultSenderEmail;
    })
    if (this.$store.state.flowCount !== null) {
      this.count = this.$store.state.flowCount;
    } else {
      getFlowCount({}, true).then(res => {
        this.count = res.data.data;
      })
    }
  }

}
